import React, { useState, useEffect, useRef } from 'react';
import { deleteCookie, getAppUser, getFactviewUsername, getCurrentUser, getCookie, removeCurrentUserSession} from '../../functions/utils';
import '../../css/header.css';
import '../../css/ProfileComponent.css';
import FactviewLogoSmall from '../../images/FactviewLogoSmall.png';
import ExactSmall from '../../images/ExactSmall.png';
import TwinfieldSmall from '../../images/TwinfieldSmall.png';
import ConfirmationComponent from '../utilities/ConfirmationComponent';
// Import the core library and icon packs you need
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircleUser, faUser, faArrowRightFromBracket, faArrowRightToBracket,faXmark, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslations  } from '../utilities/TranslationContext';


// Add the icons you will use to the library
library.add(faCircleUser, faUser, faArrowRightFromBracket, faArrowRightToBracket,faXmark, faPlus);

const ProfileComponent = () => {
  const [appUser, setAppUser] = useState(false);
  const [twinfieldLinks, setTwinfieldLinks] = useState([]);
  const [twinfieldActive, setTwinfieldActive] = useState([]);
  const [pendingConfirm, setPendingConfirm] = useState(null);
  const { getTranslation } = useTranslations();
  
  useEffect(() =>{
    fetchAppUser();
  }, []); 

  useEffect(() => {
  const refreshHandler = () => {
    fetchAppUser();
  };

  window.addEventListener("factview-profile-changed", refreshHandler);

  return () => {
    window.removeEventListener("factview-profile-changed", refreshHandler);
  };
}, []);

  useEffect(() =>{
  }, [appUser, twinfieldLinks, twinfieldActive]);

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === 'Escape') {
        const dropdownEl = document.querySelector(".profile-dropdown-container");
        if (dropdownEl && dropdownEl.classList.contains("visible")) closeDropdown();
      }
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  async function logout() {
    await fetch('https://monitor.factview.nl/?logout=1', {
      method: 'GET',
      credentials: 'include', // Send cookies with the request if needed
    }).then(response => {
      if (response.ok) {
        console.log('Logout successful');  
        
      } else {
        throw new Error('Logout failed');
      }
    }).catch(error => console.error('Error during logout:', error));
    await deleteCookie("factview_access");
    await deleteCookie("factview_refresh"); 
    await deleteCookie("session_id");
    // window.location.href = 'https://importmodule.factview.nl/app';
  }

  async function fetchAppUser(){
    var appUser = await getAppUser();
    if(appUser){
      var userName = await getFactviewUsername();
      appUser.user_name = userName.user_name;

      setAppUser(appUser);
      var twinfielLinks = await getTwinfieldLinks(appUser.user_id);
      setTwinfieldActive(twinfielLinks.find(link => link.id === appUser.integration_twinfield));

      setTwinfieldLinks(twinfielLinks);
    }
    else{
      return fetchAppUser();
    }
  }

  async function logoutFactview(){
    setPendingConfirm({
      message: getTranslation("import_LogoutConfirmFactview"),
      onConfirm: async () => {
        const response = await fetch('/app_user/logoutFactview?user_id='+await getCurrentUser());
        if (response.ok) {
          const clientId = process.env.REACT_APP_CLIENT_ID_FACTVIEW;
          const sessionId = getCookie('session_id');
          deleteCookie("factview_access");
          deleteCookie("factview_refresh");
          deleteCookie("session_id");
          await removeCurrentUserSession();
          window.location.href = 'https://monitor.factview.nl/oauth/index.php?logout=1&client_id='+clientId+'&import_session='+sessionId;
        }
      }
    });
  }

  async function logoutExactOnline(){
    setPendingConfirm({
      message: getTranslation("import_LogoutConfirmExactOnline"),
      onConfirm: async () => {
        const response = await fetch('/app_user/logoutExactOnline?user_id='+await getCurrentUser());
        if (response.ok) {
          window.location.href = 'https://importmodule.factview.nl/app';
        }
      }
    });
  }

  async function logoutTwinfield(){
    setPendingConfirm({
      message: getTranslation("import_LogoutConfirmTwinfield"),
      onConfirm: async () => {
        const response = await fetch('/app_user/logoutTwinfield?user_id='+await getCurrentUser());
        if (response.ok) {
          await twinfieldLogoutLink(twinfieldActive.id);
          window.location.href = 'https://importmodule.factview.nl/app';
        }
      }
    });
  }

  async function getTwinfieldLinks(user_id){
    const response = await fetch('/import_twinfieldlink/getByUserId?user_id='+user_id);
    if (response.ok) {
      const responseData = await response.json();

      return responseData;
    }
  }
  async function addTwinfieldAccount(){
    const response = await fetch('/app_user/logoutTwinfield?user_id='+await getCurrentUser());
      if (response.ok) {
        const responseData = await response.json();
        window.location.href = 'https://importmodule.factview.nl/app?import=twinfield';
      }
  }
  async function twinfieldLogoutLink(integration_twinfield){

      const response = await fetch('/import_twinfieldlink/removeTwinfieldLink', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_id: appUser.user_id,
        integration_twinfield: integration_twinfield,
      }),
    });
    if (response.ok) {
      window.location.href = 'https://importmodule.factview.nl/app?import=twinfield';
    } 
  }
  async function switchTwinfield(integration_twinfield){

    const response = await fetch('/app_user/switchTwinfieldIntegration', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_id: appUser.user_id,
        integration_twinfield: integration_twinfield,
      }),
    });
    if (response.ok) {
      window.location.href = 'https://importmodule.factview.nl/app?import=twinfield';
    } 
  }

  function handleClickOutsideClose(event){
    var dropdownEl = document.querySelector(".profile-dropdown-container");
    var headerProfileBtn = document.querySelector(".header-profile-btn");
    var profileCloseBtn = document.querySelector(".profile-close");
    
    if(dropdownEl && !dropdownEl.contains(event.target) && !headerProfileBtn.contains(event.target) && !profileCloseBtn.contains(event.target)){
      dropdownEl.classList.toggle("visible");
      document.removeEventListener('click', handleClickOutsideClose);
    }
  }  

  async function toggleDropdown(event){
    var dropdownEl = document.querySelector(".profile-dropdown-container");
    
    window.dispatchEvent(new Event("factview-profile-changed"));
    if(dropdownEl.classList.contains("visible")){
      document.removeEventListener('click', handleClickOutsideClose);
    }
    else{
      document.addEventListener('click', handleClickOutsideClose);
    }    

    dropdownEl.classList.toggle("visible");
  }

  async function closeDropdown(){
    var dropdownEl = document.querySelector(".profile-dropdown-container");
    dropdownEl.classList.remove("visible");
    
    document.removeEventListener('click', handleClickOutsideClose);
  }
  
  return (
    <div className="profile-component">
      {pendingConfirm && (
        <ConfirmationComponent
          message={pendingConfirm.message}
          onConfirm={pendingConfirm.onConfirm}
          onCancel={() => setPendingConfirm(null)}
        />
      )}
      <div className="profile-icon-tooltip-wrapper">
        <FontAwesomeIcon className="header-profile-btn hover" onClick={(event)=>{toggleDropdown(event)}} icon={faCircleUser}/>
      </div>
      <div className='profile-dropdown-container'>
        <div className='profile-dropdown'> 
          <div className="profile-header">
            <div className="profile-username">
              <p><FontAwesomeIcon className="username-icon" icon={faUser}/></p>
              <p>{appUser.user_name}</p>
            </div>
            <div className="profile-close hover" onClick={()=>{closeDropdown()}}>
              <FontAwesomeIcon className="profile-close-icon" icon={faXmark}/>
            </div>
          </div>
          <div className="profile-content-container">
            <div className="factview-profile-container">
              <div className="factview-profile-label">
                <p>{getTranslation("import_ImportUser")}</p>
              </div>
              <div className="profile-content factview-profile">
                <p><img src={FactviewLogoSmall} className="profile-content-img" alt="logo" />Factview</p>
                <button className='profile-logout-btn' onClick={()=>{logoutFactview()}}><FontAwesomeIcon className="logout-icon" icon={faArrowRightFromBracket}/>{getTranslation("import_Logout")}</button>
              </div>
            </div>
            <div className="profile-external-platforms"> 
              <div className="external-platforms-label">
                <p>{getTranslation("import_ConnectedPlatforms")}</p>
              </div>  
              {(!appUser.exactonline_access && !appUser.exactonline_refresh && !(twinfieldActive || Array.isArray(twinfieldLinks))) ? (
              <div className="exteral-no-platforms">
                <p>{getTranslation("import_NoUsersConnectedExternal")}</p>
              </div>
              ):(
            <div>
                {(appUser.exactonline_access || appUser.exactonline_refresh) ? (
                <div className="profile-content">
                  <p><img src={ExactSmall} className="profile-content-img" alt="logo" />Exact online</p>
                  <button className='profile-logout-btn' onClick={()=>{logoutExactOnline()}}><FontAwesomeIcon className="logout-icon" icon={faArrowRightFromBracket}/>{getTranslation("import_Logout")}</button>
                </div>
                ) : null} 
                {(twinfieldActive) || Array.isArray(twinfieldLinks) ? (
                  <div className="profile-content"> 
                  <p><img src={TwinfieldSmall} className="profile-content-img" alt="logo" />Twinfield</p>
                    {(twinfieldActive) ? (
                    <div className="twinfield-active-container">
                    <p className="twinfield-label">{twinfieldActive.organisation_code}</p>
                    <button className='profile-logout-btn' onClick={()=>{logoutTwinfield()}}><FontAwesomeIcon className="logout-icon" icon={faArrowRightFromBracket}/>{getTranslation("import_Logout")}</button>
                    </div>):null}
                    <div className="twinfield-switch-container">
                      {Array.isArray(twinfieldLinks) && 
                      twinfieldLinks.filter(link => link.id != appUser.integration_twinfield)
                      .map(link => (
                        <div className="twinfield-switch-el" key={link.id}>
                            <p className="twinfield-label">{link.organisation_code}</p>
                            <button className='profile-login-btn' onClick={()=>{switchTwinfield(link.id)}}><FontAwesomeIcon className="login-icon" icon={faArrowRightToBracket}/>{getTranslation("import_Login")}</button>
                        </div>
                    ))}
                  </div>
                    <div className="twinfield-add-el">
                        <p className="twinfield-label">{getTranslation("import_AddAccount")}</p>
                        <button className='profile-login-btn' onClick={()=>{addTwinfieldAccount()}}><FontAwesomeIcon className="login-icon" icon={faPlus}/>{getTranslation("import_Add")}</button>
                    </div>
                  </div>
                ) : null}
              
              </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileComponent;
